var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.service_requirement_employee_deferrals}},[_c('v-select',{attrs:{"options":[
      { code: 0, label: 'No' },
      { code: 1, label: 'Yes, one requirement for all employees' },
      {
        code: 2,
        label: 'Yes, multiple requirements for different employees'
      }
    ],"reduce":function (label) { return label.code; }},on:{"input":_vm.onChange},model:{value:(_vm.design.$model.service_requirement_employee_deferrals),callback:function ($$v) {_vm.$set(_vm.design.$model, "service_requirement_employee_deferrals", $$v)},expression:"design.$model.service_requirement_employee_deferrals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }